// eslint-disable-next-line import/prefer-default-export
export const selectContentOrigin = (state) => state.get('contentOrigin') || 'not-editor';
